<template>
  <header class="l-header" id="id-header">
    <h1 v-if="route.name == 'language'" class="header-seo">
      {{ titleSeo }}
    </h1>
    <!-- Logo no HTML do SSR: desktop e mobile por media query (mesmo corte do
         isMobile(), < 770), e a margem no CSS, em vez do isMobile() no template -->
    <NuxtLink :to="'/' + localeTemp" class="main-logo">
      <picture>
        <source
          media="(max-width: 769px)"
          :srcset="localeTemp == 'en' ? logoEnMobile : logoPtMobile"
        />
        <img
          :class="`logo-bella ${route.params.language == 'en' ? 'logo-bella-en' : ''}`"
          width="262"
          height="52"
          :src="localeTemp == 'en' ? logoEnDesktop : logoPtDesktop"
          alt="Logo Bella da Semana"
        />
      </picture>
    </NuxtLink>
    <!-- Social Links -->
    <ul v-if="icones.length" class="social-box social-box--dark d-none d-md-flex">
      <li v-for="icon in icones" :key="icon.slug" :class="`social-icon--${icon.slug}`">
        <a
          :href="icon.url"
          target="_blank"
          rel="noopener noreferrer"
          ><img
            :src="icon.icon"
            :alt="icon.name"
            width="22"
            height="22"
            class="icon-header"
        /></a>
      </li>
    </ul>

    <!-- Languages -->

    <div class="language-nav dropdown nav-mobile">
      <a
        href="#"
        class="dropdown-toggle"
        id="language"
        data-toggle="dropdown"
        @click.prevent="showLangMenu = !showLangMenu"
      >
        <img :src="langLinksSelect.flag" :alt="langLinksSelect.fullName" />
        <span class="language-current-name">{{ langLinksSelect.name }}</span>
      </a>
      <div
        class="dropdown-menu header-menu"
        :class="{ show: showLangMenu }"
        aria-labelledby="language"
      >
        <a
          href="#"
          v-for="(link, i) in langLinks"
          :key="i"
          class="dropdown-item"
          @click.prevent="changeLang(link.lang)"
        >
          <img :src="link.flag" :alt="link.fullName" />
          <span class="language-label">{{ link.name }}</span>
        </a>
      </div>
    </div>
    <!--Top Nav -->

    <nav class="navbar">
      <ul>
        <li
          class="navbar__item text-center d-none d-xl-block"
          :class="{ 'is-credit-download': key == 4 && storeUser.isLoggedIn }"
          v-for="{ key, name, link, bold } in listNavbar"
          :key="key"
          @click="redirect(link, key)"
          :style="key == 4 ? 'background-color: #ff6000;' : ''"
        >
          <span 
            :class="`nav-menu-header ${bold}`" 
            :style="key == 4 ? 'color: #ffffff;' : '' "
          >
            {{ name }}
          </span>
        </li>

        <li
          class="navbar__item navbar__item--highlight text-center"
          @click="redirect(storeUser.isLoggedIn ? 'language-minhaconta' : 'language-assine')"
        >
          <!-- Texto de desktop e de mobile no HTML, alternados por CSS: o Vue não
               corrige v-html na hidratação, e o isMobile() é false no SSR -->
          <span class="nav-menu-header-assine">
            <span class="assine-desktop" v-html="textoAssine.desktop"></span>
            <span class="assine-mobile" v-html="textoAssine.mobile"></span>
          </span>
        </li>
      </ul>
    </nav>
    <div class="burger-wrapper m-menu">
      <a href="#" class="burger-icon" @click.prevent="showMenuLateral()">
        <div class="d-flex align-items-center">
          <div class="">
            <div class="menu-hifens">
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
          <div class="nav-menu-header-name menu-mobile menu-label ps-1">MENU</div>
        </div>
      </a>
    </div>
    <RightNavbar
      @showMenuLateral="showMenuLateral"
      :class="{ 'show-menu': show }"
      class="right-menu"
    />
    <div class="inlive-wrapper">
      <div class="inlive-sticky" v-if="showInLiveSticky">
        <NuxtLink :to="'/' + localeTemp + '/live'" class="nav-menu-header-inlive">
          <img :src="localeTemp === 'pt-br' ? inLiveStickyImgPt : inLiveStickyImgEn" alt="Live" width="150" />
        </NuxtLink>
        <div class="close-sticky" @click="closeSticky">
          X
        </div>
      </div>
    </div>
  </header>
  <ModalPopupLive v-model:optionsLivePopup="optionsLivePopup"/>

</template>

<script setup lang="ts">
import translate from "@/tradutors/mainheader";
import FlagUnitedStates from "assets/img/Flag_of_the_United_States.webp";
import FlagBrasil from "assets/img/Flag_of_Brazil.webp";
import { useSocialNetworks, socialNetworksFor } from "@/composables/useSocialNetworks";
import logoPtDesktop from "@/assets/img/logo-pt-desktop.webp";
import logoPtMobile from "@/assets/img/logo-pt-mobile.webp";
import logoEnDesktop from "@/assets/img/logo-en-desktop.webp";
import logoEnMobile from "@/assets/img/logo-en-mobile.webp";
import RightNavbar from "../Navbar/index.vue";
import api from "@/api";
import inLiveStickyImgPt from "@/assets/img/inlivebutton-pt.png";
import inLiveStickyImgEn from "@/assets/img/inlivebutton-en.png";
import ModalPopupLive from "@/components/Modais/ModalPopupLive.vue";
import { useCookies } from "vue3-cookies";

const { cookies } = useCookies();
const props = defineProps({
  show: {
    type: Boolean,
    default: false,
  },
  // false na área do afiliado: sem o aviso e o popup de live.
  marketing: {
    type: Boolean,
    default: true,
  },
});

const route = useRoute();
const router = useRouter();

const emit = defineEmits(["showMenuLateral"]);

const storeLocale = localeStore();
const storeUser = userStore();

const navMainHeaderTradLanguage = computed(() => {
  return route.params.language === "pt-br"
    ? translate.portugues
    : translate.ingles;
});
const textoAssine = computed(() => {
  const nav = navMainHeaderTradLanguage.value.nav;
  if (!storeUser.isLoggedIn)
    return { desktop: nav.pageSubscribeLogout, mobile: nav.pageSubscribeLogoutMobile };
  return storeUser.isActiveUser
    ? { desktop: nav.pageSubscribeLogin, mobile: nav.pageSubscribeLoginMobile }
    : { desktop: nav.pageSubscribeLoginInactive, mobile: nav.pageSubscribeLoginInactiveMobile };
});

const langLinks = ref([
  {
    name: "PT",
    lang: "pt-br",
    fullName: "Português",
    flag: FlagBrasil,
  },
  {
    name: "EN",
    lang: "en",
    fullName: "English",
    flag: FlagUnitedStates,
  },
]);
const listNavbar = ref<any>(null);

// Redes sociais vêm do admin. A chave do useAsyncData é compartilhada com o
// Navbar e o Footer, então os três componentes consomem uma única requisição.
const socialNetworks = await useSocialNetworks(String(route.params.language));
const icones = computed(() => socialNetworksFor(socialNetworks.value, "header"));

const setIdLang = ref(route.params.language == "en" ? 1 : 0);
const localeTemp = ref(route.params.language);
const showLangMenu = ref(false);
const showInLiveMenu = ref(false);
const showInLiveSticky = ref(false);
const langLinksSelect = computed(() => langLinks.value[setIdLang.value]);
const titleSeo = computed(() =>
  route.params.language === "pt-br"
    ? "Ensaios Exclusivos com as Mulheres Mais Bonitas do Brasil"
    : "Exclusive photo shoots with the most beautiful women in Brazil."
);
const optionsLivePopup = ref({
  imageBanner: '',
  showModal: false,
});

onMounted(() => {
  if (import.meta.client) {
    localeTemp.value = String(route.params.language);

    setIdLang.value = localeTemp.value == "en" ? 1 : 0;

    storeLocale.setLocale(localeTemp.value);
  }
});

onMounted(() => {
  listItems();
  if (props.marketing) getInLive();
});

function getInLive() {
  api.get(`v1/live/getInLive`).then(({ data }) => {
    if (data.length && route.name != "language-live" && !route.name.includes("language-assine")) {
      showInLiveMenu.value = true;
      if (!sessionStorage.getItem("inLiveStickyClosed")) {
        showInLiveSticky.value = true;
      }
      if (!sessionStorage.getItem("inLiveBannerClosed") && !cookies.isKey("bellaPromoShow")) {
        if (route.params.language == "pt-br" && data[0].banner_pt) {
          optionsLivePopup.value = {
            imageBanner: data[0].banner_pt,
            showModal: document.getElementById('modalLegalWarning') == null ? true : false,
          };
        } else if (route.params.language == "en" && data[0].banner_en) {
          optionsLivePopup.value = {
            imageBanner: data[0].banner_en,
            showModal: document.getElementById('modalLegalWarning') == null ? true : false,
          };
        }
      }
    }
  });
}

function closeSticky() {
  showInLiveSticky.value = false;
  sessionStorage.setItem(
    "inLiveStickyClosed",
    JSON.stringify(true)
  );
}

function redirect(name: string, key?: number) {
  router.push({ name, params: { language: route.params.language}, query: key == 4 ? { tab: 1 } : {} });
}

function changeLang(locale: string) {
  showLangMenu.value = false;
  // after this change a hook will trigger
  storeLocale.setLocale(locale);
  localeTemp.value = locale;

  let newUrl = router.currentRoute.value.fullPath;
  localeTemp.value == "pt-br"
    ? (newUrl = newUrl.replace(/en/, localeTemp.value))
    : (newUrl = newUrl.replace(/pt-br/, localeTemp.value));

  router.push(`${newUrl}`);
}
function showMenuLateral() {
  emit("showMenuLateral", !props.show);
}

function listItems() {
  setIdLang.value = localeTemp.value === "en" ? 1 : 0;
  listNavbar.value = [
    {
      name: navMainHeaderTradLanguage.value.nav.models,
      key: 1,
      link: "language-modelos",
      bold: route.name.includes("language-modelos") ? "item-bold" : "",
    },
    {
      name: navMainHeaderTradLanguage.value.nav.videos,
      key: 2,
      link: "language-videos",
      bold: route.name.includes("language-videos") ? "item-bold" : "",
    },
    {
      name: navMainHeaderTradLanguage.value.nav.makingof,
      key: 3,
      link: "language-making-of",
      bold: route.name.includes("language-making-of") ? "item-bold" : "",
    },
    {
      name: navMainHeaderTradLanguage.value.nav.lives,
      key: 6,
      link: "language-lives",
      bold: route.name.includes("language-lives") ? "item-bold" : "",
    },
    {
      name: storeUser.isLoggedIn
        ? navMainHeaderTradLanguage.value.nav.minhaConta
        : navMainHeaderTradLanguage.value.nav.login,
      key: 5,
      link: storeUser.isLoggedIn ? "language-minhaconta" : "language-login",
      bold:
        route.name == "language-minhaconta" || route.name == "language-login"
          ? "item-bold"
          : "",
    },
    {
      name: storeUser.isLoggedIn ? navMainHeaderTradLanguage.value.nav.creditDownload : navMainHeaderTradLanguage.value.nav.freeTour,
      key: 4,
      link: storeUser.isLoggedIn ? "language-minhaconta" : "language-freetour",
      bold: route.name == "	language-freetour" ? "item-bold" : "",
    },
  ];
}

watch(
  () => localeTemp.value,
  () => {
    listItems();
  }
);

watch(
  () => storeUser.isLoggedIn,
  () => {
    listItems();
  }
);

watch(
  () => storeLocale.locale,
  (value) => {
    localeTemp.value = value;
    listItems();
  }
);
</script>

<style lang="scss">
.burger-wrapper {
  width: 104px;
  height: 100%;
  position: relative;
  margin-top: 4px;

  .burger-icon {
    position: absolute;
    top: 0;
    right: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    z-index: 103;

    span {
      display: block;
      width: 18px;
      height: 2px;
      margin-bottom: 3px;
      background: #1d1d1d;
      border-radius: 3px;
      transition: transform 0.5s cubic-bezier(0.77, 0.2, 0.05, 1),
        opacity 0.55s ease;
    }
  }
}

.language-nav {
  width: 60px;
  height: 24px;
  margin: 7px;
  display: block;
}

.language-nav a img {
  border-radius: 50%;
  width: 22px;
  height: 22px;
  object-fit: cover;
  top: -2px;
  margin-right: 3px;
}

.language-nav a {
  font-family: "Exo-2";
  vertical-align: unset;
  top: 0px;
  color: #666666;
}

.language-nav .dropdown-toggle:after {
  top: -1px;
  color: rgba(0, 0, 0, 0.5);
}

.logo-bella {
  display: block;
  width: 262px;
  height: 52px;
  top: -3px;
}

/* era 10px inline (isMobile() no template); até 769px vale o 5px da regra mobile */
.main-logo {
  margin-left: 10px;
}

.nav-menu-header {
  /* centraliza o texto (H+V) sem line-height; o span preenche a área do item
     (width/height 100%) e a quebra continua acontecendo na largura do <li>, como
     antes. Itens regulares não têm <br>, então o flex no próprio span é seguro. */
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  color: #000000;
  font-family: "Bebas-Neue";
  font-size: 20px;
  font-weight: 400;
  /* aperta o espaçamento quando o texto quebra em 2 linhas (ex.: AMOSTRA GRÁTIS,
     DOWNLOAD CRÉDITOS); não afeta itens de 1 linha, que o flex já centraliza. */
  line-height: 1.3;
  margin-top: 3px;
}

.nav-menu-header-name {
  color: #000000;
  font-family: "Bebas-Neue";
  font-size: 20px;
  letter-spacing: 0;
  line-height: 24px;
}

.nav-menu-header-assine {
  /* o conteúdo vem por v-html e pode ter <br> (UP<br>GRADE), então aqui mantemos
     o fluxo normal (sem flex no span, senão o <br> não quebraria) e centralizamos
     pelo <li> .navbar__item--highlight (flex). width:100% mantém a quebra na
     largura do item e text-align centraliza as linhas. */
  width: 100%;
  color: #ffffff;
  font-family: "Bebas-Neue";
  font-size: 20px;
  letter-spacing: 0;
  text-align: center;
  /* mesmo aperto entre linhas para "ASSINE AGORA"/UP<br>GRADE quando vão a 2 linhas */
  line-height: 1.3;
  margin-top: 6px;  
}

.nav-menu-header-inlive {
  display: block;
  width: 150px;
  height: auto;
}

.nav-menu-header-inlive img {
  display: block;
  width: 150px;
  height: auto;
}

.navbar__item {
  width: 90px;
  height: 65px;
  padding: 0px;
  border-color: rgba(0, 0, 0, 0.1);
  letter-spacing: 1px;
}

.navbar__item--highlight {
  /* item sempre visível (sem d-none/d-xl-block), então podemos usar flex no
     próprio <li> para centralizar o "Assine" (que contém <br>) vertical e
     horizontalmente, sem line-height. */
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "Bebas-Neue";
}

.social-box li {
  margin-right: 6px;
}

// O ícone do Facebook precisa de um ajuste fino de tamanho. O seletor era
// `li:nth-child(2)`, que amarrava o estilo à posição na lista — com a ordem
// agora configurável no admin, o ajuste passaria a valer para a rede errada.
// A classe vem do slug, então acompanha a rede em qualquer posição.
.social-box--dark li.social-icon--facebook img {
  width: 20px;
  height: 20px;
}

.social-box--dark {
  margin-right: 10px;
}

.menu-mobile {
  transform: translate(0%, 0%);
}

/* Itens que eram v-if="!isMobile()" (ou trocavam de texto por ele): agora vão
   no HTML do SSR e o CSS escolhe, com o mesmo corte (< 770) */
.assine-desktop,
.assine-mobile {
  /* o `* { font-family }` do app.vue vale para todo elemento: sem isto os spans
     não herdam a Bebas-Neue do botão e saem em Exo-2 */
  font-family: inherit;
}
.assine-mobile {
  display: none;
}

.header-seo {
  position: absolute;
  color: white;
  font-size: 5px;
}

.l-header {
  position: fixed !important;
  height: 65px !important;
}

.item-bold {
  font-weight: 700;
}

.menu-hifens {
  float: right;
}

.down-menu {
  top: -85px;
}

.dropdown-menu {
  background-color: #ffffff;
}

.header-menu {
  z-index: 109;
}

.navbar li:nth-child(7) span {
  color: #ffffff;
  font-weight: 300;
}

.inlive-wrapper {
    width: 150px;
    position: absolute;
    top: 150px;
    right: 70px;
}

.inlive-sticky {
  position: fixed;
  z-index: 110;
}

.close-sticky {
  font-family: "Roboto-Regular";
  position: absolute;
  top: -9px;
  right: -14px;
  color: #4B4B4B;
  width: 20px;
  height: 20px;
  text-align: center;
  line-height: 20px;
  cursor: pointer;
}

.navbar__item:nth-child(5), .navbar__item:nth-child(6), .navbar__item:nth-child(7) {
  letter-spacing: 0px !important;
  width: 110px;  
}

.language-label {
  margin-left: 5px;
}

@media (min-width: 769px) {
  .main-logo {
    width: 258px;
    height: 40px;
  }
}

@media screen and (max-width: 1255px) {
  .navbar__item:nth-child(5), .navbar__item:nth-child(6), .navbar__item:nth-child(7) {
    letter-spacing: 0px !important;
    width: 90px;  
  }
}

@media screen and (max-width: 769px) {
  .language-current-name,
  .menu-label,
  .assine-desktop {
    display: none;
  }
  .assine-mobile {
    display: inline;
  }

  .navbar__item {
    width: 100px;
  }

  .burger-wrapper {
    max-width: 85px;
  }

  .navbar__item {
    height: 65px;
  }

  /* line-height só no header (não nos navbar__item): centraliza verticalmente o
     conteúdo inline do header no mobile — em especial a bandeira do seletor de
     idioma, que não tem line-height próprio. Os spans do navbar não herdam isso
     porque definem o próprio line-height (0.9). */
  .l-header {
    height: 65px;
    line-height: 65px;
  }

  .navbar__item:nth-child(7) {
    width: 60px;
  }

  .navbar li:nth-child(6) span, .navbar li:nth-child(7) span  {
    font-weight: 600 !important;
    letter-spacing: 0px !important;
  }

  .menu-mobile {
    font-size: 19px;
    transform: translate(5%, 5%);
  }

  .language-nav a {
    top: -20px;
  }

  .nav-mobile {
    left: 10px;
  }
  .nav-menu-header-assine {
    font-size: 16px;
  }

  .dropdown-item {
    height: 40px;
  }

  .down-menu {
    top: -110px;
  }
  .header-menu {
    top: 30px;
  }
  .language-nav {
    width: 30px;
    left: 6px;
  }
  .inlive-sticky img {
    height: auto;
    width: 100px;      
  }
  .inlive-wrapper {
    width: 100px;
    top: 100px;
    right: 30px;
  }  
  .close-sticky {
    top: -10px;
    right: 35px;
  }

  .logo-bella {
    width: 95px;
    height: 33px;
    top: 3px;
  }

  .logo-bella-en {
    width: 95px;
    top: unset;
  }

  .burger-wrapper .burger-icon span {
    height: 3px;  
    margin-bottom: 5px;
    width: 21px;
  }  

  .m-menu {
    width: 40px !important;
  }  

  .main-logo {  
    margin-left: 5px;
    width: 90px;
  }

  .navbar__item:nth-child(6) {
    display: block !important;
    width: 60px !important;
    font-weight: 300;
  }

  .nav-menu-header {
    font-size: 16px !important;
  }
  .navbar__item:nth-child(1) {
    display: block !important;
    width: 60px !important;
  }

  .language-nav a img {
    width: 16px;
    height: 16px;
    margin-right: 1px;
  }

  .language-nav .dropdown-toggle:after {
    font-size: 13px;
  }
}

@media screen and (max-width: 1430px) {
  .navbar__item,
  .burger-wrapper {
    width: 85px;
  }
}

@media screen and (max-width: 1375px) {
  .navbar__item,
  .burger-wrapper {
    width: 75px;
  }
}

/* === Tablet/iPad (770–1199px): mantém o header desktop (logo desktop, ícones
   sociais, troca de idioma, Assine e MENU) e ADICIONA o "Amostra Grátis" (6º
   item), que no desktop só aparece em >=1200px via d-xl-block. Os demais itens
   horizontais (Modelos/Vídeos/Making of/Lives/Login) seguem acessíveis pelo
   botão MENU (right navbar). === */
@media screen and (min-width: 770px) and (max-width: 1199px) {
  /* "Amostra Grátis" no MESMO formato do desktop: uma única linha, bloco laranja
     com largura conforme o texto e mesma font-size do "Assine Agora" (20px).
     A centralização vertical vem do flex em .nav-menu-header (height:100%).
     O 6º item está escondido por padrão no tablet (d-none), por isso o
     display:block !important para exibi-lo. Já o 7º (Assine) está sempre visível
     e centraliza pelo flex do <li> .navbar__item--highlight, então NÃO pode virar
     block aqui (senão o texto sobe para o topo). */
  .navbar__item:nth-child(6) {
    display: block !important;
    width: 110px !important;
    white-space: nowrap;
    text-align: center;
  }
  .navbar__item:nth-child(7) {
    width: 110px !important;
    white-space: nowrap;
  }
  .navbar__item:nth-child(6) .nav-menu-header {
    width: auto;
    height: 100%;
    font-size: 20px;
    white-space: nowrap;
  }
  /* Logado, o 6º item passa a exibir "DOWNLOAD CRÉDITOS". Diferente do "Amostra
     Grátis" (deslogado, mantido em 1 linha acima), esse texto deve quebrar em 2
     linhas já a partir do tablet — como já ocorre no desktop (>=1200px). Restaura
     o comportamento desktop (width:63px + quebra) só para esse caso. */
  .navbar__item.is-credit-download,
  .navbar__item.is-credit-download .nav-menu-header {
    white-space: normal;
  }
  .navbar__item.is-credit-download .nav-menu-header {
    width: 100%;
  }
  /* compacta o espaçamento lateral para tudo caber já a partir de 770px */
  .social-box li {
    margin-right: 3px;
  }
  .social-box--dark {
    margin-right: 4px;
  }
}

/* "Bellas" (1º item, key 1) volta a aparecer a partir de 900px — fica oculto
   apenas na faixa 770–899px (onde falta largura no header). No mobile (<=769px)
   continua visível pela regra própria e em >=1200px pelo d-xl-block. */
@media screen and (min-width: 900px) and (max-width: 1199px) {
  .navbar__item:nth-child(1) {
    display: block !important;
  }
}

/* faixa de tablet em retrato (770–1023px, ex.: iPad 10.9"=810, Air=820, Pro 11"=834):
   reduz o logo e os ícones sociais para que logo + social + idioma + Amostra Grátis
   (agora em 1 linha, largo como no desktop) + Assine + MENU caibam sem quebrar.
   Em 1024px+ (paisagem) há largura sobrando e mantém-se o tamanho cheio. */
@media screen and (min-width: 770px) and (max-width: 1023px) {
  .logo-bella {
    width: 210px;
    height: auto;
  }
  .social-box li {
    margin-right: 1px;
  }
  .icon-header {
    width: 19px;
    height: 19px;
  }
}

@media screen and (min-width: 770px) and (max-width: 786px) {
  .navbar__item:nth-child(6), .navbar__item:nth-child(7) {
      width: 100px !important;
  }  
}
</style>
